import type {
  ChargePoint,
  RequestCommandChangeConfiguration,
  RequestCommandDataTransfer,
  RequestCommandReset,
} from '../../../app/ApiGen';
import type { ConfigurationKey } from '../../../utils/chargePoints/commands';
import type { UpdateFirmwareFields } from '../../../utils/firmware';
import type { Normalised } from '../../../utils/request';

export enum CommandType {
  NO_COMMAND = '',
  UPDATE_FIRMWARE = 'update-firmware',
  RESET = 'reset',
  CHANGE_CONFIGURATION = 'change-configuration',
  DATA_TRANSFER = 'data-transfer',
}

export type ResetStepFields = { resetType: RequestCommandReset['resetType'] };
export type DataTransferStepFields = { messageId: RequestCommandDataTransfer['messageId'] };
export type ChangeConfigurationStepFields = {
  configurationKey: ConfigurationKey;
  configurationValue: RequestCommandChangeConfiguration['value'];
};

// Each command type carries only the fields its step collects; the wizard may have filled in
// none/some/all of them, so variant-specific fields are Partial. Using a discriminated union on
// `type` lets `switch (command.type)` narrow to the right payload without casts.
export type Command =
  | ({ type: CommandType.UPDATE_FIRMWARE } & Partial<UpdateFirmwareFields>)
  | ({ type: CommandType.RESET } & Partial<ResetStepFields>)
  | ({ type: CommandType.CHANGE_CONFIGURATION } & Partial<ChangeConfigurationStepFields>)
  | ({ type: CommandType.DATA_TRANSFER } & Partial<DataTransferStepFields>)
  | { type: CommandType.NO_COMMAND };

export type CommandState = { command: Command };

export type CommandsWizardState = {
  chargePoints: ChargePointState[];
} & CommandState;

export type ChargePointState = Pick<Normalised<ChargePoint>, 'id' | 'name' | 'ocppChargePointId' | 'serial' | 'vendor'>;
